import { cached } from './cache';

// 읍·면·동 경계(SGIS 행정동 경계, vuski/admdongkor ver20261001 · CC BY 4.0)를 시·군·구 단위 파일로 받습니다.
export const loadDongs = sggId => cached(`geo:${sggId}`, 24 * 60 * 60 * 1000, () =>
  fetch(`${process.env.PUBLIC_URL || ''}/geo/${sggId}.json`).then(r => { if (!r.ok) throw new Error(`geo ${r.status}`); return r.json(); }));

const bboxOf = coords => {
  let s = 90, w = 180, n = -90, e = -180;
  for (const poly of coords) for (const [x, y] of poly[0]) { if (y < s) s = y; if (y > n) n = y; if (x < w) w = x; if (x > e) e = x; }
  return [s, w, n, e];
};
const inRing = (x, y, ring) => {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i], [xj, yj] = ring[j];
    if ((yi > y) !== (yj > y) && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) inside = !inside;
  }
  return inside;
};
const inMulti = (x, y, coords) => coords.some(poly => inRing(x, y, poly[0]) && !poly.slice(1).some(h => inRing(x, y, h)));

// 온도 5단계 (차가움 → 따뜻함)
export const HEAT_COLORS = ['#a9c8ff', '#d7e6ff', '#fff1b8', '#ffb36b', '#f2603c'];

// 지점별 최고 금리를 읍·면·동 폴리곤에 배정하고, 화면에 보이는 동네끼리 상대 온도를 매깁니다.
export function buildHeat(collections, places) {
  const features = [];
  for (const fc of collections) for (const f of fc.features) {
    const box = f._box || (f._box = bboxOf(f.geometry.coordinates));
    features.push({ f, box, rate: null, count: 0, top: null });
  }
  for (const p of places) {
    const hit = features.find(x => p.lat >= x.box[0] && p.lat <= x.box[2] && p.lng >= x.box[1] && p.lng <= x.box[3] && inMulti(p.lng, p.lat, x.f.geometry.coordinates));
    if (!hit) continue;
    hit.count += 1;
    if (hit.rate == null || p.rate > hit.rate) { hit.rate = p.rate; hit.top = p.name; }
  }
  const rates = features.filter(x => x.rate != null).map(x => x.rate).sort((a, b) => a - b);
  const min = rates[0] ?? null, max = rates[rates.length - 1] ?? null;
  const step = v => (max == null || max === min ? 4 : Math.min(4, Math.floor(((v - min) / (max - min)) * 5)));
  const ranked = features.filter(x => x.rate != null).sort((a, b) => b.rate - a.rate);
  return {
    min, max, count: rates.length,
    hottest: ranked.slice(0, 3).map(x => ({ id: x.f.properties.id, name: x.f.properties.n, rate: x.rate, top: x.top, count: x.count })),
    geojson: {
      type: 'FeatureCollection',
      features: features.map(x => ({ type: 'Feature', geometry: x.f.geometry, properties: {
        id: x.f.properties.id, n: x.f.properties.n, rate: x.rate, count: x.count, top: x.top,
        color: x.rate == null ? '#9aa3b2' : HEAT_COLORS[step(x.rate)], has: x.rate == null ? 0 : 1,
      } })),
    },
  };
}
